import React from 'react';
import Navigation from '../components/Navigation';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <SEO
        title="Contact Bond Boxing Gym | Gaborone, Botswana"
        description="Contact Bond Boxing Gym in Gaborone, Botswana. Enquire about boxing classes, gym memberships, personal training and youth boxing programmes. Get started today."
        path="/contact"
      />

      <Navigation />

      {/* Hero Section */}
      <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://i.imgur.com/nZlamyN.jpeg"
            alt="Bond Boxing training and fitness"
            className="w-full h-full object-cover"
            fetchPriority="high"
            decoding="async"
          />

          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 tracking-wider">
            Join The <span className="text-red-600">Ranks</span>
          </h1>

          <p className="text-gray-300 text-lg md:text-xl">
            Get in touch to start your boxing journey with us.
          </p>
        </div>
      </section>

      <ContactSection />

      <Footer />
    </div>
  );
};

export default ContactPage;